module.exports = __webpack_public_path__ + "9d825fba1bb3fc6b4fc53456fbc47926.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/whats-new/update/2018-04-24/whats-new.html
// module id = 2326
// module chunks = 0